import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import RequestHelper from '../../../utils/Request.Utils';
import DefaultAvatarSvg from '../../../assets/images/default-avatar-filled.svg';
import * as CONSTANTS from '../../../constants';
import './ManageUser.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

import DefaultAvatar from '../../../sharedComponents/DefaultAvatar/DefaultAvatar';

const foo = [{ "ID": 114, "createdAt": "2021-05-25T08:28:18.675371Z", "updatedAt": "2021-05-25T08:30:47.06233Z", "deletedAt": null, "name": "Grace", "avatar": "", "email": "gracecd@devserver.london", "phone": "07676767676", "country": "UK", "role": "broker", "jobTitle": "" }, { "ID": 117, "createdAt": "2021-05-25T08:45:10.22105Z", "updatedAt": "2021-05-25T08:45:10.22105Z", "deletedAt": null, "name": "G Client", "avatar": "", "email": "gclient@devserver.london", "phone": "07676767676", "country": "UK", "role": "client", "jobTitle": "" }, { "ID": 120, "createdAt": "2021-05-25T09:42:57.596447Z", "updatedAt": "2021-05-25T09:42:57.596447Z", "deletedAt": null, "name": "Test User", "avatar": "//burgess-shared-tour.devserver.london/files/upload-1621935777-Theatro360-favicon.png", "email": "test@theatro360.com", "phone": "07989404004", "country": "United Kingdom", "role": "broker", "jobTitle": "" }, { "ID": 121, "createdAt": "2021-05-26T05:33:10.152807Z", "updatedAt": "2021-05-26T05:33:10.152807Z", "deletedAt": null, "name": "Huy Le C", "avatar": "", "email": "hbc@devserver.london", "phone": "123456", "country": "VN", "role": "client", "jobTitle": "" }, { "ID": 122, "createdAt": "2021-05-27T07:58:13.292558Z", "updatedAt": "2021-05-27T07:58:13.292558Z", "deletedAt": null, "name": "HB2", "avatar": "", "email": "hb2@devserver.london", "phone": "123456", "country": "VN", "role": "broker", "jobTitle": "Dev" }, { "ID": 123, "createdAt": "2021-05-27T18:41:51.704518Z", "updatedAt": "2021-05-27T18:41:51.704518Z", "deletedAt": null, "name": "Sebastian Le Fleur", "avatar": "//burgess-shared-tour.devserver.london/files/upload-1622140911-IMG_9677.JPG", "email": "sebastian@theatro360.com", "phone": "07897495795", "country": "uk", "role": "broker", "jobTitle": "Director" }, { "ID": 115, "createdAt": "2021-05-25T08:43:09.467055Z", "updatedAt": "2021-05-28T07:57:48.012495Z", "deletedAt": null, "name": "hb", "avatar": "", "email": "hb@devserver.london", "phone": "123456", "country": "VN", "role": "broker", "jobTitle": "" }, { "ID": 119, "createdAt": "2021-05-25T09:18:58.293223Z", "updatedAt": "2021-05-28T12:20:53.499507Z", "deletedAt": null, "name": "Peter Test 3", "avatar": "//burgess-shared-tour.devserver.london/files/upload-1621934338-Screenshot 2021-05-25 at 10.15.56.png", "email": "peter@codesigned.co.uk", "phone": "07595384567", "country": "UK", "role": "broker", "jobTitle": "" }, { "ID": 124, "createdAt": "2021-05-28T12:22:47.398406Z", "updatedAt": "2021-05-28T12:22:47.398406Z", "deletedAt": null, "name": "Peter Broker 28th May", "avatar": "//burgess-shared-tour.devserver.london/files/upload-1622204566-AdobeStock_214398097.jpeg", "email": "group@codesigned.co.uk", "phone": "07595384567", "country": "UK", "role": "broker", "jobTitle": "Director" }, { "ID": 125, "createdAt": "2021-05-28T12:29:27.238403Z", "updatedAt": "2021-05-28T12:29:27.238403Z", "deletedAt": null, "name": "GraceHost", "avatar": "", "email": "gracehost@devserver.london", "phone": "07676767666", "country": "UK", "role": "broker", "jobTitle": "Host" }, { "ID": 139, "createdAt": "2021-07-15T08:21:18.940495Z", "updatedAt": "2021-07-15T08:21:18.940495Z", "deletedAt": null, "name": "Mark Woodmansey", "avatar": "", "email": "mwoodmansey@burgessyachts.com", "phone": "+85264962094", "country": "Hong Kong", "role": "broker", "jobTitle": "Head of Brokerage Asia" }, { "ID": 126, "createdAt": "2021-06-01T10:21:32.181092Z", "updatedAt": "2021-06-01T10:21:32.181092Z", "deletedAt": null, "name": "Peter", "avatar": "", "email": "peterhost@devserver.london", "phone": "07676767667", "country": "United Kingdom", "role": "broker", "jobTitle": "Testing Host" }, { "ID": 127, "createdAt": "2021-06-01T11:27:27.526498Z", "updatedAt": "2021-06-01T11:27:27.526498Z", "deletedAt": null, "name": "Brandon Stonebridge", "avatar": "", "email": "brandon@techster.co.uk", "phone": "07914020308", "country": "United Kingdom", "role": "client", "jobTitle": "Software Developer" }, { "ID": 128, "createdAt": "2021-06-11T14:02:35.733061Z", "updatedAt": "2021-06-11T14:02:35.733061Z", "deletedAt": null, "name": "Greg Olszowski", "avatar": "", "email": "golszowski@burgessyachts.com", "phone": "07714560155", "country": "United Kingdom", "role": "broker", "jobTitle": "Head of Digital" }, { "ID": 129, "createdAt": "2021-06-21T04:28:45.758694Z", "updatedAt": "2021-06-21T04:28:45.758694Z", "deletedAt": null, "name": "Huy Le", "avatar": "", "email": "lequanghuylc@gmail.com", "phone": "+841674053250", "country": "Vn", "role": "broker", "jobTitle": "Dev" }, { "ID": 130, "createdAt": "2021-06-21T05:01:00.320903Z", "updatedAt": "2021-06-21T05:01:00.320903Z", "deletedAt": null, "name": "HuyLeDev", "avatar": "", "email": "autogenerated_HuyLeDev", "phone": "", "country": "", "role": "broker", "jobTitle": "" }, { "ID": 131, "createdAt": "2021-06-21T08:06:45.215668Z", "updatedAt": "2021-06-21T08:06:45.215668Z", "deletedAt": null, "name": "CD Dev", "avatar": "", "email": "cddev@devserver.london", "phone": "", "country": "", "role": "broker", "jobTitle": "" }, { "ID": 132, "createdAt": "2021-06-21T15:39:41.446162Z", "updatedAt": "2021-06-21T15:39:41.446162Z", "deletedAt": null, "name": "Test", "avatar": "", "email": "nametest@devserver.london", "phone": "", "country": "", "role": "broker", "jobTitle": "" }, { "ID": 133, "createdAt": "2021-06-23T09:17:59.842168Z", "updatedAt": "2021-06-23T09:17:59.842168Z", "deletedAt": null, "name": "HB3", "avatar": "", "email": "hb3@devserver.london", "phone": "", "country": "", "role": "broker", "jobTitle": "" }, { "ID": 134, "createdAt": "2021-07-06T19:20:05.628546Z", "updatedAt": "2021-07-06T19:20:05.628546Z", "deletedAt": null, "name": "Robert Vermilye", "avatar": "", "email": "rvermilye@burgessyachts.com", "phone": "7865991354", "country": "United States", "role": "broker", "jobTitle": "Brokerage Assistant" }, { "ID": 116, "createdAt": "2021-05-25T08:44:20.298052Z", "updatedAt": "2021-07-15T14:25:48.544266Z", "deletedAt": null, "name": "Richard Shead", "avatar": "//burgess-shared-tour.devserver.london/files/upload-1621932260-RShead.jpeg", "email": "rshead@theatro360.com", "phone": "+44 7734 961552", "country": "United Kingdom", "role": "broker", "jobTitle": "" }, { "ID": 135, "createdAt": "2021-07-15T08:15:12.306545Z", "updatedAt": "2021-07-15T08:15:12.306545Z", "deletedAt": null, "name": "Richard", "avatar": "", "email": "rlambert@burgessyachts.com", "phone": "+33634860255", "country": "Monaco", "role": "broker", "jobTitle": "Head of Sales" }, { "ID": 136, "createdAt": "2021-07-15T08:15:20.416597Z", "updatedAt": "2021-07-15T08:15:20.416597Z", "deletedAt": null, "name": "Ed Cavendish", "avatar": "", "email": "ecavendish@burgessyachts.com", "phone": "07837843830", "country": "UK", "role": "broker", "jobTitle": "Producer" }, { "ID": 137, "createdAt": "2021-07-15T08:15:34.489217Z", "updatedAt": "2021-07-15T08:15:34.489217Z", "deletedAt": null, "name": "James Clark", "avatar": "", "email": "jclark@burgessyachts.com", "phone": "+447766525799", "country": "United Kingdom", "role": "broker", "jobTitle": "Head of Retail Charter" }, { "ID": 118, "createdAt": "2021-05-25T08:50:36.803242Z", "updatedAt": "2021-07-15T08:18:37.273358Z", "deletedAt": null, "name": "Jonathan Lucas", "avatar": "//burgess-shared-tour.devserver.london/files/upload-1621932636-Jon-selfie.jpg", "email": "jon@theatro360.com", "phone": "+44 7989 404004", "country": "United Kingdom", "role": "broker", "jobTitle": "" }, { "ID": 138, "createdAt": "2021-07-15T08:20:49.888117Z", "updatedAt": "2021-07-15T08:20:49.888117Z", "deletedAt": null, "name": "Zejna Lelic ", "avatar": "", "email": "zlelic@burgessyachts.com", "phone": "07921541135 ", "country": "United Kingdom", "role": "broker", "jobTitle": "" }, { "ID": 140, "createdAt": "2021-08-02T12:30:12.211327Z", "updatedAt": "2021-08-02T12:30:12.211327Z", "deletedAt": null, "name": "Georgia Walton", "avatar": "", "email": "gwalton@burgessyachts.com", "phone": "+447931983909", "country": "United Kingdom", "role": "broker", "jobTitle": "Central Agency Listings Manager" }, { "ID": 141, "createdAt": "2021-08-03T03:56:20.448039Z", "updatedAt": "2021-08-03T03:56:20.448039Z", "deletedAt": null, "name": "Admin", "avatar": "", "email": "admin@devserver.london", "phone": "", "country": "", "role": "admin", "jobTitle": "" }];

function generate_token(length){
  //edit the token allowed characters
  var a = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890".split("");
  var b = [];  
  for (var i=0; i<length; i++) {
      var j = (Math.random() * (a.length-1)).toFixed(0);
      b[i] = a[j];
  }
  return b.join("");
}

const ManageUser = () => {
  const [filterRole, setFilterRole] = useState({ label: 'All', value: '' });
  const [list, setList] = useState([]);
  const [upsertData, setUpsertData] = useState({
    showUI: false,
    data: {
      ID: 0,
      name: '',
      email: '',
      password: '',
      role: '',
    },
  });
  useEffect(() => {
    const getList = async () => {
      const res = await RequestHelper.get('/users/list-users', {});
      if (res.data.data) setList(res.data.data);
    };
    getList();
  }, []);

  const updateUserRole = async (id, role, previousRole) => {
    const res = await RequestHelper.post('/users/change-user-role', {
      id, role, previousRole
    });
    if (!res.data.success) alert('An error occcurs');
  }

  const options = Object.keys(CONSTANTS.ROLES).map(val => ({
    label: CONSTANTS.ROLES[val],
    value: val,
  }));
  const withoutAdminOptions = options.filter(val => val.value !== 'admin');
  const withoutGuestOptions = options.filter(val => val.value !== 'client');

  const filteredList = (() => {
    if (!filterRole.value) return list.filter(val => val.role !== 'client');
    return list.filter(u => u.role === filterRole.value);
  })();

  const removeUser = async ({ ID, name, email }) => {
    const shouldRemove = window.confirm(`Are you sure you want to remove this user ${name} (${email})?`);
    if (!shouldRemove) return;
    const res = await RequestHelper.post('/users/admin-remove-user', {
      id: ID,
    });
    if (!res.data.success) alert('An error occcurs');
    setList(list.filter(val => val.ID !== ID));
    alert('The account has been removed');
  }

  const resetPassword = async ({ ID, name, email }) => {
    const shouldReset = window.confirm(`Are you sure you want to reset the password of this user ${name} (${email})?`);
    if (!shouldReset) return;
    const randomPassword = window.location.href.includes('lifearc') ? `lifearc@2022!${generate_token(4)}` : `theatro360@2022!${generate_token(4)}`;
    const res = await RequestHelper.post('/users/admin-reset-user-password', {
      id: ID,
      newPassword: randomPassword,
    });
    if (!res.data.success) alert('An error occcurs');
    const newList = list.slice();
    const index = list.findIndex(val => val.ID === ID);
    if (index === -1) return;
    // @ts-ignore
    newList[index].password = randomPassword;
    setList(newList);
  }

  const onFormSubmit = async e => {
    e.preventDefault();
    if (!upsertData.data.role) return alert('Please fill all the fields');
    const res = await RequestHelper.post('/users/admin-add-user', {
      ...upsertData.data,
    });
    if (!res.data.success) alert('An error occcurs');
    const newList = list.slice();
    newList.push(res.data.data.user);
    setList(newList);
    alert('The account has been added');
    setUpsertData({
      showUI: true,
      data: {
        ID: 0,
        name: '',
        email: '',
        role: '',
        password: '',
      },
    });
  }
  return (
    <div>
      <div className="filter-row">
        <div style={{ width: 320 }}>
          <div>
            <p><b>Filter:</b></p>
          </div>

          <Select
            value={filterRole}
            options={[
              { label: 'All', value: '' },
              ...withoutGuestOptions,
            ]}
            onChange={(newData) => {
              setFilterRole(newData);
            }}
          />
        </div>
        <button className="add-new-button" onClick={() => setUpsertData({ ...upsertData, showUI: true })}>Add new user</button>
      </div>

      {upsertData.showUI && (
        <>
        <hr />
          <form className="user-upsert-form" onSubmit={onFormSubmit}>
            <input
              required
              className="input form-group form-control" placeholder="Name"
              value={upsertData.data.name} onChange={(e) => setUpsertData({ ...upsertData, data: { ...upsertData.data, name: e.target.value } })}
            />
            <input
              required
              className="input form-group form-control" placeholder="Email"
              value={upsertData.data.email} onChange={(e) => setUpsertData({ ...upsertData, data: { ...upsertData.data, email: e.target.value } })}
            />
            <input
              required
              className="input form-group form-control" placeholder="Password"
              type="password"
              value={upsertData.data.password} onChange={(e) => setUpsertData({ ...upsertData, data: { ...upsertData.data, password: e.target.value } })}
            />
            <label>
              <input
                type="checkbox"
                checked={upsertData.data.role === "admin"}
                onChange={(e) => setUpsertData({ ...upsertData, data: { ...upsertData.data, role: e.target.checked ? 'admin' : '' } })}
              />
              <span style={{ marginLeft: 15, marginRight: 15 }}>Admin</span>
              <input
                type="checkbox"
                checked={upsertData.data.role === "broker"}
                onChange={(e) => setUpsertData({ ...upsertData, data: { ...upsertData.data, role: e.target.checked ? 'broker' : '' } })}
              />
              <span style={{ marginLeft: 15 }}>Host</span>
            </label>
            <div>
              <input type="submit" value="Submit" />
              <button
                className="cancel" onClick={e => {
                  e.preventDefault();
                  setUpsertData({
                    showUI: false,
                    data: {
                      ID: 0,
                      name: '',
                      email: '',
                      role: '',
                      password: '',
                    },
                  });
                }}
              >
                Cancel
              </button>
            </div>
          </form>
        </>
      )}

      <hr />
      <div className="row manage-user-container">
        {filteredList.map((user, i) => (
          <div
            key={'user-row' + i}
            className="col-md-6 col-xs-12 user-row"
          >
            {Boolean(!user.avatar) ? (
              <DefaultAvatar width={50} height={50} style={{ marginRight: 20 }} />
            ) : (
              <img src={user.avatar} alt="" />
            )}
            <div>
              <p><b>Name:</b> {user.name} <span onClick={() => removeUser(user)} style={{ float: 'right', padding: 4, cursor: 'pointer' }}><FontAwesomeIcon icon={faTimes} color={CONSTANTS.COLOR.MAIN} /></span></p>
              <p><b>Email:</b> {user.email}</p>
              {user.password && (
                <p><b>Password:</b> {user.password}</p>
              )}
              <p><b>Created At:</b> {user.createdAt}</p>

              <div>
                <p>
                  <b>Role:</b> {user.role === 'admin' ? CONSTANTS.ROLES['admin'] : ''}
                  <span onClick={() => resetPassword(user)} style={{ float: 'right', cursor: 'pointer', textDecorationLine: 'underline' }}>Reset password</span>
                </p>
                <Select
                  value={options.find(val => val.value === user.role)}
                  options={withoutGuestOptions}
                  onChange={(newData) => {
                    const shouldDoIt = window.confirm('Are you sure you want to change role of this user?');
                    if (!shouldDoIt) return;
                    updateUserRole(user.ID, newData.value, user.role);
                    const newList = list.slice();
                    const findIndex = list.findIndex(val => val.ID === user.ID);
                    if (findIndex !== -1) {
                      newList[findIndex].role = newData.value;
                      setList(newList);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ManageUser;
